import { 
  FETCH_ASSETS_START, 
  FETCH_ASSETS_SUCCESS, 
  FETCH_AVAILABLE_ASSETS_START,
  FETCH_AVAILABLE_ASSETS_SUCCESS,
  FETCH_AVAILABLE_ASSETS_ERROR,
  FETCH_REFERENCE_CURRENCY_ERROR, 
  FETCH_REFERENCE_CURRENCY_START, 
  FETCH_REFERENCE_CURRENCY_SUCCESS, 
  FETCH_DEPOSIT_ADDRESS_ERROR,
  FETCH_DEPOSIT_ADDRESS_SUCCESS,
  FETCH_DEPOSIT_ADDRESS_START
} from './actionTypes'

const initialState = {
  loading: false,
  error: '',
  assets: [],
  depositAddress: {},
  depositAddressLoading: false,
  availableAssets: [], // State for available assets from root endpoint
  availableAssetsLoading: false,
  availableAssetsError: '',
  referenceCurrency: null,
  referenceCurrencyLoading: false,
  referenceCurrencyError: '',
}

const assetsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ASSETS_START:
      return {
        ...state,
        loading: true,
      }
    case FETCH_ASSETS_SUCCESS:
      return {
        ...state,
        loading: false,
        assets: [...action.payload],
      }
    case FETCH_REFERENCE_CURRENCY_START:
      return {
        ...state,
        referenceCurrencyLoading: true,
        referenceCurrencyError: '',
      }
    case FETCH_REFERENCE_CURRENCY_SUCCESS:
      return {
        ...state,
        referenceCurrencyLoading: false,
        referenceCurrency: action.payload,
      }
 
    // Handle actions for fetching available assets from root endpoint
    case FETCH_AVAILABLE_ASSETS_START:
      return {
        ...state,
        availableAssetsLoading: true,
        availableAssetsError: '',
      }
    case FETCH_AVAILABLE_ASSETS_SUCCESS:
      return {
        ...state,
        availableAssetsLoading: false,
        availableAssets: action.payload,
      }
    case FETCH_AVAILABLE_ASSETS_ERROR:
      return {
        ...state,
        availableAssetsLoading: false,
        availableAssetsError: action.error,
      }
    case FETCH_DEPOSIT_ADDRESS_START:
      return {
        ...state,
        depositAddressLoading: true,
        depositAddressError: '',
      }
    case FETCH_DEPOSIT_ADDRESS_SUCCESS:
      return {
        ...state,
        depositAddress: action.payload,
      }
    case FETCH_DEPOSIT_ADDRESS_ERROR:
      return {
        ...state,
        depositAddressLoading: false,
        depositAddressError: action.error,
      }
    default:
      return { ...state }
  }
}
export default assetsReducer
